export const PROFILES = [
  { id: 1, nombre: "Administrador" },
  { id: 2, nombre: "Docente" },
  { id: 3, nombre: "Estudiante" },
];
